module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the beginning of each semester a trail of students from the previous semester makes its way to my office. In almost every case, they come to complain about the grade they received in my course. Naturally I decline to discuss their grade but I do take the opportunity to congratulate them for the courage they show in opening themselves to a review and critique of their performance in the semester previous. It takes courage to look squarely at one’s choices, especially when those choices are wrong ones (as indicated by the analog indicator of performance we call grades).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In some cases, my congratulations are well placed: as we go over their work, especially the final exam, they see and acknowledge how they missed the point, or conflated unrelated matters, or failed to see connections, or skipped studying. I admire these students for their intellectual generosity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In other cases, though, all they want to talk about is that analog indicator, the final grade. Our review of the final, to them, might as well be Snoopy going “Wah wah wah.” They keep returning to their bottom line: “I am a good student. I am an A student, not a Cminus student.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fnInt_1",
      "id": "Intfn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" All in the full–blown tragic mode.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have come to the realization, after many years, that they are expressing an unshakeable conviction. No evidence avails to counter it. And that conviction resides not in their rational faculties but in the imagination. It is deep within them, and carries a powerful weight of emotion.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46afe7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Introduction.vue
// module id = 81
// module chunks = 0